import { useSelector } from 'react-redux';

export default function useDictionary(ids, type) {
  const { dictionary } = useSelector(({ app }) => app);

  switch (type) {
    case 'genres': {
      const dictGenres = dictionary && dictionary?.genres;
      const hasGenres = !!ids?.length && dictGenres;

      return hasGenres ? ids.map(id => dictGenres.find(item => item.id === id) || {}) : [];
    }
    case 'devices': {
      const dictDevices = dictionary && dictionary?.device_groupings;
      const hasDevices = !!ids?.length && dictDevices;

      return hasDevices ? ids.map(id => dictDevices.find(item => item.id === id) || {}) : [];
    }
    case 'channels': {
      const dictChannels = dictionary && dictionary?.channels;
      const hasChannels = !!ids?.length && dictChannels;

      return hasChannels
        ? ids
            .map(id => dictChannels.find(item => item.id === id) || null)
            .filter(item => item !== null)
        : [];
    }
    default:
      return [];
  }
}
